import React, { useReducer } from 'react';
import StoreGroupContext from './storeGroupContext';
import StoreGroupReducer from './storeGroupReducer';
import { IStoreGroup } from 'src/interfaces/storeGroup';
import { clearState, setLoading } from '../utils';
import { DEFAULT_STORE_GROUP_STATE } from './constants/defaultState';
import { IStoreGroupState, TStoreGroupPagination } from './types';
import {
    getStoreGroup,
    getStoreGroups,
    updateStoreGroup,
    deleteStoreGroup,
    createStoreGroup,
    getAllStoreGroups,
} from './utils';

const StoreGroupState = ({ children }: IStoreGroupState) => {
    const [state, dispatch] = useReducer(
        StoreGroupReducer,
        DEFAULT_STORE_GROUP_STATE
    );

    return (
        <StoreGroupContext.Provider
            value={{
                ...state,
                clearStoreGroupState: () =>
                    clearState(dispatch, DEFAULT_STORE_GROUP_STATE),
                setLoading: () => setLoading(dispatch),
                getStoreGroup: (storeGroupId: string) =>
                    getStoreGroup(dispatch, storeGroupId),
                getStoreGroups: (
                    pagination: TStoreGroupPagination,
                    query?: string
                ) => getStoreGroups(dispatch, pagination, query),
                getAllStoreGroups: () => getAllStoreGroups(dispatch),
                updateStoreGroup: (
                    storeGroup: Partial<IStoreGroup>,
                    storeGroupId: string
                ) => updateStoreGroup(dispatch, storeGroupId, storeGroup),
                deleteStoreGroup: (storeGroupId: string) =>
                    deleteStoreGroup(dispatch, storeGroupId),
                createStoreGroup: (storeGroup: Partial<IStoreGroup>) =>
                    createStoreGroup(dispatch, storeGroup),
            }}
        >
            {children}
        </StoreGroupContext.Provider>
    );
};

export default StoreGroupState;
